import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { Lock, Eye, EyeOff, CheckCircle, AlertCircle } from 'lucide-react';
import apiService from '../../services/api';
import '../../styles/login.scss';

const ResetPassword: React.FC = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') || '';

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [show, setShow] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (password.length < 6) { setError('La contraseña debe tener al menos 6 caracteres'); return; }
    if (password !== confirm) { setError('Las contraseñas no coinciden'); return; }
    setLoading(true);
    try {
      await apiService.post('/auth/reset-password', { token, password });
      setDone(true);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err: any) {
      setError(err?.response?.data?.message || 'No se pudo restablecer la contraseña');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container flex items-center justify-center py-12 px-4">
      <div className="login-box">
        <div className="login-logo">
          <img src="/img/mitsui_logo_corporate.svg" alt="MITSUI & CO." />
        </div>

        {!token ? (
          <div style={{ textAlign: 'center' }}>
            <AlertCircle size={40} style={{ color: 'var(--danger)', margin: '0 auto 12px' }} />
            <h3 style={{ marginBottom: 8 }}>Enlace inválido</h3>
            <p style={{ color: 'var(--text-secondary)', fontSize: 14 }}>Falta el token. Solicita un nuevo enlace.</p>
            <Link to="/forgot-password" className="forgot-password" style={{ display: 'inline-block', marginTop: 18 }}>
              Solicitar enlace
            </Link>
          </div>
        ) : done ? (
          <div style={{ textAlign: 'center' }}>
            <CheckCircle size={40} style={{ color: 'var(--green)', margin: '0 auto 12px' }} />
            <h3 style={{ marginBottom: 8 }}>Contraseña actualizada</h3>
            <p style={{ color: 'var(--text-secondary)', fontSize: 14 }}>Te llevamos a iniciar sesión…</p>
          </div>
        ) : (
          <>
            <div className="login-header">
              <p>Crea tu nueva contraseña</p>
            </div>
            <form onSubmit={handleSubmit}>
              {error && <div className="error-message"><span className="error-text">{error}</span></div>}
              <div className="form-group">
                <label htmlFor="password">Nueva contraseña</label>
                <div className="input-wrapper">
                  <Lock className="input-icon" />
                  <input id="password" type={show ? 'text' : 'password'} value={password}
                    onChange={(e) => setPassword(e.target.value)} placeholder="Mínimo 6 caracteres" required />
                  <button type="button" className="toggle-password" onClick={() => setShow(!show)}>
                    {show ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
                  </button>
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="confirm">Confirmar contraseña</label>
                <div className="input-wrapper">
                  <Lock className="input-icon" />
                  <input id="confirm" type={show ? 'text' : 'password'} value={confirm}
                    onChange={(e) => setConfirm(e.target.value)} placeholder="Repite la contraseña" required />
                </div>
              </div>
              <button type="submit" disabled={loading} className="login-button">
                {loading ? 'Guardando…' : 'Restablecer contraseña'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
